const userApi = {
  "获取用户数据":{
    apiUrl:"users/userdata",
    hasNode:false,
    params:[{
        name:"token",
        required:'否',
        type:'String',
        text:"您要检测的链接",
        default:localStorage.getItem('key')
      }],
    resultKey:[
      {
        name:"status",
        type:'String',
        text:`正常(success),异常(error)`,
      },{
        name:"data",
        type:'Array',
        text:`查询结果`,
      },{
        name:"data.id",
        type:'Number',
        text:`您的用户ID`,
      },{
        name:"data.point",
        type:'Number',
        text:`您的检测点数`,
      },{
        name:"data.balance",
        type:'Number',
        text:`您的账户余额`,
      },{
        name:"data.monitored",
        type:'Number',
        text:`您已使用的监控额度`,
      },{
        name:"data.monitor",
        type:'Number',
        text:`您总共的监控额度`,
      }
    ],
    resultJson:{
      code:200,
      msg:"具体见返回值"
    }
  },
}

export default userApi
